var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vconsoleSwitch",on:{"click":_vm.btnClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }